import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectNotifications } from '@/store/notifications-new/selectors';
import { selectUsers } from '@/store/users/selectors';

import { Badge, message, Typography } from 'antd';
import { HiDotsHorizontal, HiOutlineBookOpen, HiOutlineCollection, HiOutlineStatusOffline } from 'react-icons/hi';
import { PiListChecksBold } from 'react-icons/pi';

import useIsMobile from '@shared/hooks/useIsMobile';
import { domainCompanyid } from '@shared/utils/domainCompanyId';

import Utils from '@/Utils';
import classNames from 'classnames';

import css from './MobileNav.module.scss';

const MobileNav = ({ pathname, openBurgerMenu, setOpenBurgerMenu }) => {
  const navigate = useNavigate();
  const { Text } = Typography;
  const { t } = useTranslation('header');
  const { unReadNotifications } = useSelector(selectNotifications);
  const { currentUser } = useSelector(selectUsers);

  const [isMobile] = useIsMobile(540);

  const [isOnline, setIsOnline] = useState(Utils.isOnline());

  const onRedirect = path => {
    navigate(path);
    if (openBurgerMenu) setOpenBurgerMenu(false);
  };

  const handleOfflineClick = () => message.info(t('youAreOffline'));
  const updateStatus = () => setIsOnline(Utils.isOnline());

  useEffect(() => {
    window.addEventListener('online', updateStatus);
    window.addEventListener('offline', updateStatus);

    return () => {
      window.removeEventListener('online', updateStatus);
      window.removeEventListener('offline', updateStatus);
    };
  }, []);

  return (
    <div id='mobile-nav' className={css['MobileNav']}>
      {currentUser?.domainCompany?.id !== domainCompanyid.BIDZAAR && (
        <div
          onClick={isOnline ? () => onRedirect('/collection-topics') : () => handleOfflineClick()}
          className={classNames(
            css['MobileNav__item'],
            pathname.includes('collection-topics') && css['MobileNav__item_active'],
            !isOnline && css['MobileNav__item_disabled']
          )}
        >
          <HiOutlineCollection size={isMobile ? 22 : 28} />
          <Text className={css['MobileNav__item__text']} strong={isOnline} disabled={!isOnline}>
            {t('collectionTopics')}
          </Text>
        </div>
      )}
      <div
        onClick={() => onRedirect('/d360v2')}
        className={classNames(css['MobileNav__item'], pathname.includes('planning') && css['MobileNav__item_active'])}
      >
        <PiListChecksBold size={isMobile ? 22 : 28} />
        <Text className={css['MobileNav__item__text']} strong>
          {t('d360v2')}
        </Text>
      </div>
      {/* Закомментировал по задаче https://kampus.atlassian.net/browse/KAM-7842
      <div
        onClick={isOnline ? () => onRedirect('/planning') : () => handleOfflineClick()}
        className={classNames(
          css['MobileNav__item'],
          pathname.includes('planning') && css['MobileNav__item_active'],
          !isOnline && css['MobileNav__item_disabled']
        )}
      >
        <HiOutlineBookOpen size={isMobile ? 22 : 28} />
        <Text className={css['MobileNav__item__text']} strong={isOnline} disabled={!isOnline}>
          {t('planning')}
        </Text>
      </div> */}
      {/* <div
        onClick={() => onRedirect('/offline-materials')}
        className={classNames(
          css['MobileNav__item'],
          pathname.includes('offline-materials') && css['MobileNav__item_active']
        )}
      >
        <HiOutlineStatusOffline size={isMobile ? 22 : 28} />
        <Text className={css['MobileNav__item__text']} strong>
          {t('offlineMaterials')}
        </Text>
      </div> */}
      <div
        className={classNames(css['MobileNav__item'], {
          [css['MobileNav__item_active']]: openBurgerMenu,
          [css['MobileNav__item_disabled']]: !isOnline,
        })}
        onClick={isOnline ? () => setOpenBurgerMenu(!openBurgerMenu) : () => handleOfflineClick()}
      >
        <Badge
          className={css['MobileNav__item--bell']}
          count={unReadNotifications?.length ? unReadNotifications.length : 0}
          overflowCount={99}
          offset={[5, -7]}
        >
          <HiDotsHorizontal size={isMobile ? 22 : 28} />
          <Text className={css['MobileNav__item__text']} strong={isOnline} disabled={!isOnline}>
            {t('more')}
          </Text>
        </Badge>
      </div>
    </div>
  );
};

export default MobileNav;
